import { createResourceStore, type ResourceStore } from "@/lib/resource";
import type { FinanceAccount } from "./FinanceAccount";
import type { FinanceTransaction } from "./FinanceTransaction";
import type { Order } from "./Order";
import type { Product } from "./Product";
import type { StockBatch } from "./StockBatch";
import type { Sale } from "./Sale";
import type { FinanceDebt } from "./FinanceDebt";
import { apiClient } from "@/lib/http";

export interface SaleReturn {
  id: string;
  order_id: string;
  sale_id: string;
  stock_batch_id: string;
  product_id: string;
  quantity: number;
  amount: number;
  reason: string;
  finance_account_id: string;
  payment_method: string;
  status: string;
  created_at: string;
  updated_at: string;
  order: Order;
  sale: Sale;
  stock_batch: StockBatch;
  product: Product;
  financeAccount: FinanceAccount;
  transactions: FinanceTransaction[];
  debts: FinanceDebt[];
}

export interface SaleReturnCandidate {
  product: any;
  id: string;
  selected: boolean;
  sale: Sale;
  quantity: number;
  amount: number;
  reason: string;
}
interface SaleReturnStore extends ResourceStore<SaleReturn> {
  createMany: (returns: Partial<SaleReturn>[]) => Promise<any>;
}

export const useSaleReturn = createResourceStore<SaleReturn, SaleReturnStore>(
  "sale-returns",
  () => ({
    stats: {
      filters: {
        start_date: null,
        end_date: null,
      },
      total_returns_count: 0,
      total_returned_qty: 0,
      total_returned_amount: 0.0,
      refunded_amount: 0.0,
      pending_refunds: 0.0,
      series: {
        labels: [],
        datasets: [],
      },
      top_returned_items: [],
      top_returned_categories: [],
      top_reasons: [],
    },

    createMany: (returns: Partial<SaleReturn>[]) => {
      return apiClient().post("/sale-returns/many", { returns });
    },
  })
);

export const getTotalRefundableAmount = (candidates: SaleReturnCandidate[]) => {
  return candidates
    .map((item) => parseFloat(item.quantity as any) * item.sale.selling_price)
    .reduce((sum, item) => sum + item, 0);
};

export const getRefundAmount = (candidates: SaleReturnCandidate[]) => {
  return candidates
    .map((item) => parseFloat(item.amount as any))
    .reduce((sum, item) => sum + item, 0);
};
